import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgCloudIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.394 5.586a4.752 4.752 0 0 1 9.351.946 3.75 3.75 0 0 1-.668 7.464A.757.757 0 0 1 12 14H4a.75.75 0 0 1-.179-.021 4.25 4.25 0 0 1-.427-8.393Zm.72 6.914h7.762a.745.745 0 0 1 .186-.008A2.25 2.25 0 1 0 12.25 8H12a.75.75 0 0 1-.75-.75v-.5a3.25 3.25 0 0 0-6.476-.402.75.75 0 0 1-.697.657 2.75 2.75 0 0 0-.024 5.488.74.74 0 0 1 .062.007Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const CloudIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgCloudIcon} />;
});
CloudIcon.displayName = 'CloudIcon';
export default CloudIcon;
